export default function NotFound(){
    return (
        <>
         <h1>not found</h1>
        </>
    );
}